import { ErrorResponse } from '@models/error.response';
import { TranslateService } from '@ngx-translate/core';
import { MainComponent } from '../main/main.component';
import { of, from } from 'rxjs';
import { ActionType } from '@type/action.type';
import { AppConstant } from '@constants/app.constant';
import { NgForm } from '@angular/forms';
import { FormValidationUtil } from '@utils/form.validation';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core';
import swal from 'sweetalert2';
import { switchMap, map, flatMap, filter, toArray, mergeMap, reduce } from 'rxjs/operators';
import { User } from '@app/models/user';
import { AdminUserService } from '@app/services/admin-user-service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectUtil } from '@app/utils/ng-select-utils';
import { OnepageTemplate, OnepageTemplateConfig, OnepageTemplateFieldTypeConfig } from '@app/models/onepage-template';
import { OnepageField, FieldType } from '@app/models/onepage-template-field';
import * as FileSaver from 'file-saver';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
import { OnepageTemplateField } from '../onepage-template-field/onepage-template-field.component';
import { CommonService } from '@app/services/common.service';
import { MapObjectUtil } from '@app/utils/map-object-util';
import { OnepageTemplateService } from '@app/services/onepage-template.service';
import { UUID } from 'angular2-uuid';
import { HtmlTemplateService } from '@app/services/html-template.service';
import { HtmlTemplate } from '@app/models/html-template';
import { BinaryFile } from '@app/models/binary-file';
import { BinaryFileService } from '@app/services/binary-file.service';
import { UploadOutput } from 'ngx-uploader';
import { ApplicationFile } from '@app/models/application-file';
import { CommonResponse } from '@app/models/common-model';
import { OnepageTemplateConfigService } from '@app/services/onepage-template-config.service';


declare var toastr: any;
const MAX_DOCUMENT_FILE_SIZE: number = 4 * 1024 * 1024;

@Component({
    templateUrl: './onepage-template-setup.component.html',
    styleUrls: ['./onepage-template-setup.component.scss']
})
export class OnepageTemplateSetupComponent {
    @ViewChildren(NgSelectComponent) ngSelects: QueryList<NgSelectComponent>;
    selectAll = NgSelectUtil.selectAll
    @ViewChild('workflowForm', { static: false }) workflowForm: NgForm;
    @ViewChild('taskConfigSelector', { static: false }) taskConfigSelector: OnepageTemplateField;
    @ViewChild('documentFileSelect', { static: false }) documentFileSelect: ElementRef;
    @ViewChild('documentFileSelect4Icon', { static: false }) documentFileSelect4Icon: ElementRef;
    isFieldError = FormValidationUtil.isFieldError;
    action: ActionType;
    loading: boolean = false;
    clickSave: boolean = false;
    isShowAdd:boolean = false;
    isShowUpdate:boolean = false;
    statusInInit=null;
    errorCount: number = 0;
    labelFontFamilyOptions: string[] =['','Arial','Helvetica','Times New Roman','Courier New','Zeyada','Tecnico','Roboto','Taipei Sans TC Beta'];
   
    reservedFieldIdWords: string[] =['orderDate','button4ProductName',
    'num','price','curr',
    'amt','merCode','merRef','customPriceMessage','lang','pageUrl',
    'quotaSet','quotaLeft','isCustomPrice'];



    defaultHtmlTemplate: HtmlTemplate[];
    publishLanguageOptions: string[]=['EN_AND_TC','EN','TC'];
    
    htmlTemplateFileOptions: string[]=['designA.png'];
    templateFieldLocationOptions: string[]=['default'];
    record: OnepageTemplate;
    onepageTemplateConfig: OnepageTemplateConfig;
    selectedTemplateFile: any;
    maxFieldSeq = 1;
    imgFile: BinaryFile;
    pageIconImage: BinaryFile;
    binaryFileApplication: ApplicationFile;

    allFieldTypes: FieldType[];

    constructor(
        private adminUserService: AdminUserService,
        private workFlowFormService: OnepageTemplateService,
        private htmlTemplateService: HtmlTemplateService,
        private router: Router,
        private route: ActivatedRoute,
        private mainComponent: MainComponent,
        private commonService: CommonService,
        private translate: TranslateService,
        public appConstant: AppConstant,
        private htmlTemplateConfigService: OnepageTemplateConfigService,
        protected binaryFileService: BinaryFileService) {
    }

    ngOnInit(): void {
        this.record = new OnepageTemplate();
        this.record.publishLanguage='EN_AND_TC';
        let companyCode =  this.commonService.getCurrentUser().companyCode;
       
        this.route.params
            .pipe(
                switchMap((params: Params) => {
                    this.loading = true;
                    if (params['id'] === 'new') {
                        this.action = 'CREATE';
                        this.isShowAdd = this.commonService.showAddButton(this.action,'PERM_ONEPAGE_TEMPLATE_CREATE');
                    } else {
                        this.action = 'EDIT';
                        this.isShowUpdate = this.commonService.showUpdateButton(this.action,'PERM_ONEPAGE_TEMPLATE_UPDATE');
                    }
                    return of(params);
                }),
                switchMap((params: Params) => { 
                    return of(params);
                }),
                switchMap((params: Params) => {
                    if (this.action == 'CREATE') {
                        let form = new OnepageTemplate();
                        // let task = new OnepageField();
                         form.onePageFields = [];
                        return of(form);
                    } else {
                        return this.workFlowFormService.get(params['id'])
                    }
                })
            )
            .subscribe((workflowForm: OnepageTemplate) => {
                this.record = workflowForm;
                this.statusInInit = this.record.status;
                if(!this.record.publishLanguage){
                    this.record.publishLanguage='EN_AND_TC';
                }
                
                this.imgFile = this.record.companyTemplateLogoImage;
                this.pageIconImage = this.record.pageIconImage;
                 
                
                if (this.action == 'CREATE') {
                    this.record.onepageTemplateCode = ""+Date.now();
                    this.record.merCode = companyCode;
                    this.addTaskByDefault('phone','Phone','PHONE');
                    this.addTaskByDefault('email','Email','EMAIL');
                    this.addTaskByDefault('deliveryAddress','Delivery Address','TEXT');
                }

                this.htmlTemplateService.findByCondition('stratus','ENABLED').subscribe(
                    result => {
                      this.defaultHtmlTemplate = result;
                      
                        if(!this.record.templateFileName){
                            this.selectedTemplateFile = this.defaultHtmlTemplate[0].htmlTemplateImage;
                            this.record.templateFileName = this.defaultHtmlTemplate[0].templateName;
                            this.templateFieldLocationOptions = this.getLocationList(this.defaultHtmlTemplate[0].locationValue);// ['A','B'];
                            this.changeSelectedTemplateFile(0);
                        }else{
                            var theHtmlTemp = null;
                            for(var i=0; i<this.defaultHtmlTemplate.length; i++){
                                var dp = this.defaultHtmlTemplate[i];
                                if(dp.templateName==this.record.templateFileName){
                                    theHtmlTemp = dp;
                                    break;
                                }
                            }
                            if(theHtmlTemp){
                                this.selectedTemplateFile = theHtmlTemp.htmlTemplateImage;
                                this.templateFieldLocationOptions = this.getLocationList(theHtmlTemp.locationValue);// ['A','B'];
                                this.changeSelectedTemplateFile(i);
                            }
                        }
                        
                  });

        
       
                if (this.record.onePageFields && this.record.onePageFields.length > 0) {

                    if(this.action == 'CREATE'){
                       this.record.onePageFields.forEach(formTask => {
                           // formTask.sequence=1;
                        });
                    }else if(this.action == 'EDIT'){
                        this.record.onePageFields.forEach(formTask => {
                            if(formTask.sequence>this.maxFieldSeq){
                                this.maxFieldSeq = formTask.sequence;
                            }
                            formTask._uiFlagId = UUID.UUID();
                        });
                       
                        this.record.onePageFields.sort(this.compare2);
                    }
                }
                // if (this.record.fieldType == 'COMPANY') {
                //     this.taskTypeOptions = this.taskTypeOptions.concat(this.companyTaskTypeOptions);
                // }
                this.loading = false;
            });

    }

    addDefaultTask(){
            if(this.onepageTemplateConfig && this.onepageTemplateConfig.defaultOnePageFields
                    && this.onepageTemplateConfig.defaultOnePageFields.length>0){
                for(var i=0; i<this.onepageTemplateConfig.defaultOnePageFields.length; i++){
                    var defaultOnePageField = this.onepageTemplateConfig.defaultOnePageFields[i];
                    
                    this.addTaskByDefault(defaultOnePageField.fieldId, defaultOnePageField.fieldName,
                                            defaultOnePageField.fieldType as FieldType);
                }
            }else if(!this.record.onePageFields || this.record.onePageFields.length==0){
                this.addTaskByDefault('phone','Phone','PHONE');
                this.addTaskByDefault('email','Email','EMAIL');
                this.addTaskByDefault('deliveryAddress','Delivery Address','TEXT');
            }
        
    }
    
    compare2(value1:OnepageField, value2:OnepageField): number {
        var section1 = value1.location;
        var section2 = value2.location;
        var seq1 = value1.sequence;
        var seq2 = value2.sequence;
        if(section1==section2){
            return seq1 - seq2;
        }

        return section1 > section2 ? 1: -1;
    }
    
    sortField(){
        if (this.record.onePageFields && this.record.onePageFields.length > 0) {
            this.record.onePageFields.sort(this.compare2);
        }
    }

    showInputAccordingly(fieldId: string, theLangForField:string){
        return this.record.publishLanguage=='EN_AND_TC'|| this.record.publishLanguage==theLangForField;
    }

    getLocationList(locationValue): string[]{
        return locationValue.split(",");
    }

    addTask() {
        let formTask = new OnepageField();
        this.maxFieldSeq++;
        formTask.sequence=this.maxFieldSeq;
        this.record.onePageFields.push(formTask);
    }
    
    addTaskByDefault(id: string, fieldName: string, fieldType: FieldType){
        let formTask = new OnepageField();
        formTask.fieldId = id;
        formTask.fieldName = fieldName;
        formTask.defaultSystemField = true;
        formTask.fieldType = fieldType;
        // this.maxFieldSeq++;
        // formTask.sequence=this.maxFieldSeq;
        this.record.onePageFields.push(formTask);
    }

    remove(task: OnepageField) {
        var index = this.record.onePageFields.indexOf(task);
        this.record.onePageFields.splice(index, 1);
    }

    
    isReservedKeyWord(formTask: OnepageField): boolean {
        var entityValue = formTask.fieldId;
        if(entityValue){
            return this.reservedFieldIdWords.indexOf(entityValue) >=0;
        }
        return false;
    }

    isDuplicatedUniqueField(formTask: OnepageField): boolean {
        var entityValue = formTask.fieldId;
        if(entityValue){
            var num = 0;
            for(var i=0; i<this.record.onePageFields.length; i++){
                var of = this.record.onePageFields[i];
                if(of.fieldId==entityValue){
                    num++;
                }
            }

            if(num>1){
                return true;
            }
        }
        return false;
    }
 

    onFieldFieldIdChange(task: OnepageField, taskType: string) {
        if(task.fieldId){
            task.fieldId=task.fieldId.replace(/\s+/g,"").replace(/['"]/g,"");
        }
    }
    onFieldLocationChange(task: OnepageField, taskType: string) {
        
        task.location = taskType;

    }

    changeSelectedTemplateFile(indexOfDefaultOptions) {
        const htmltemp = this.defaultHtmlTemplate[indexOfDefaultOptions];

        this.selectedTemplateFile = htmltemp.htmlTemplateImage;
        this.record.templateFileName = htmltemp.templateName;
        this.templateFieldLocationOptions = this.getLocationList(htmltemp.locationValue);
    }

    trimGap(fieldName: string): void{
        let field = this.workflowForm.controls[fieldName];
        if(field){
            console.log(field);
            field['fieldId']='www';
            document.getElementsByName(fieldName)[0].setAttribute('value','ggg');
        }
    }

    isEmptyTask(): boolean {
        let result = this.record.onePageFields && (this.record.onePageFields.length == 0);
        return result;
    }

    isEmptyTaskConfig(formTask: OnepageField): boolean {
        // this task type no need to check the config.
        // if (formTask && formTask.taskType == 'COMPANY_REGISTER_GEN') {
        //     return false;
        // }
        if (this.record.onePageFields.find(t => t == formTask) != null) {
            return false;//formTask.taskConfig == null;
        }
        return false;
    }

    deleteDoc(): void{
        let instance = this;
        let txt = 'CONFIRM_TO_DELETE_THE_ONEPAGE_TEMPLATE';
        
        this.translate.get([txt,
        'CONFIRM',
        'CANCEL'])
        .subscribe(res => {
            swal.fire({
                text: res[txt],
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: res.CANCEL,
                confirmButtonText: res.CONFIRM
            }).then(result => {
                if (result.value) {
                       instance.loading = false;
                       instance.record.status='DELETED';
                       this.__delete();
                }
            });
        });
    }

    
    private __delete(): void {
        
        this.mainComponent.enableLoadingMask();
        this.loading = true;

        this.workFlowFormService.delete(this.record.id)
            .subscribe((response: CommonResponse) => {
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                if(response.content.status=='SUCCESS'){
                    this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.DELETE_ONEPAGE_TEMPLATE_SUCCESS))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });

                    this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_PATH]);
                }else{
                    this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(response.content.message))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'error',
                            title: res
                        });
                    });
                }
            }, (error: ErrorResponse) => {
                 this.mainComponent.disableLoadingMask();
                this.loading = false;
            });
    }
 


    save(isSaveAndDeploy?:boolean): void {
        if(!isSaveAndDeploy){
            this.clickSaveAndDeploy = false;
        }else{
            this.clickSaveAndDeploy = true;
        }

        this.clickSave = true;
        //check form for just clicking save without any input
        for (let key of Object.keys(this.workflowForm.controls)) {
            this.workflowForm.controls[key].markAsDirty();
        }


        
        for(var i=0; i<this.record.onePageFields.length; i++){
            var dp = this.record.onePageFields[i];
            if (!dp.isValid2Submit) {
                return;
            }
            if(dp.fieldId.indexOf(" ")>=0){
                dp.fieldId=dp.fieldId.replace(/\s+/g,"").replace(/['"]/g,"");
            }
        }
        

        var px = this.record.templateFileName.indexOf(".");
        if(px>0){
            this.record.templateFileCode = this.record.templateFileName.substring(0, px);
        }

        if (this.workflowForm.valid) {
             this.record.companyTemplateLogoImage = this.imgFile;
             this.record.pageIconImage = this.pageIconImage;

            // this.record.templateFileName = MapObjectUtil.setOtherLocaleValueAsCurrentLocale(this.record.templateFileName,'en')
            switch (this.action) {
                case 'CREATE':
                    this.create();
                    break
                case 'EDIT':
                    this.update();
                    break;
            }
        }
    }

    private initFormTask() {
        this.record.onePageFields.forEach(formTask => {
            // if (formTask._selectedUsername.length == 0) {
            //     this.isValid2Submit = false;
            // } else {
            //    // formTask.assignUsers = formTask._selectedUsername.join(AppConstant.USER_TASK_ASSIGN_NAME);
            // }
        });
    }

    clickSaveAndDeploy: boolean = false;
    

    private create(): void {

        this.mainComponent.enableLoadingMask();
        this.loading = true;

        this.workFlowFormService.insert(this.record)
            .subscribe(() => {
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_PATH]);

                this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_ADDED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                    });
            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;
                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_ADD, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });

                        });
                });
    }

    private update(): void {

        this.mainComponent.enableLoadingMask();
        this.loading = true;

        this.workFlowFormService.update(this.record)
            .subscribe(record => {
                this.record = record;
                this.mainComponent.disableLoadingMask();
                this.loading = false;

                this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_PATH]);

                this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                    .pipe(
                        switchMap(typeStr => this.translate.get(AppConstant.HAS_BEEN_UPDATED, { type: typeStr }))
                    )
                    .subscribe(res => {
                        swal.fire({
                            type: 'success',
                            title: res
                        });
                        
                        if(this.clickSaveAndDeploy){
                            this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_DEPLOYMENT_PATH+'/ID_'+this.record.id]);
                        }
                    });

            },
                (error: ErrorResponse) => {
                    this.mainComponent.disableLoadingMask();
                    this.loading = false;


                    from(error.errors)
                        .pipe(
                            mergeMap(error => this.translate.get(error.errorCode)),
                            reduce((acc, value) => acc + value + '<br/>', '')
                        )
                        .subscribe(msg => {

                            this.translate.get(ModulePathConstant.TEMPLATE_CENTER_MODULE)
                                .pipe(
                                    switchMap(typeStr => this.translate.get(AppConstant.FAIL_TO_UPDATE, { type: typeStr }))
                                )
                                .subscribe(title => {
                                    swal.fire({
                                        type: 'error',
                                        title: title,
                                        html: msg
                                    });
                                });
                        });
                })

    }

    cancel(): void {
        this.router.navigate([ModulePathConstant.ONEPAGE_TEMPLATE_PATH]);
    }

    getFileTypeOptionsForTemplate(): FieldType[]{
        if(this.action=='EDIT'){
                
        }

        return this.allFieldTypes;
    }
    
    getDisabledUiFieldIds(formTask: OnepageField): OnepageTemplateFieldTypeConfig{
        if(this.onepageTemplateConfig && this.onepageTemplateConfig.onepageTemplateFieldTypeConfigs){
            var fieldType = formTask.fieldType as string;
            for(var i=0; i<this.onepageTemplateConfig.onepageTemplateFieldTypeConfigs.length; i++){
                var item = this.onepageTemplateConfig.onepageTemplateFieldTypeConfigs[i];
                if(item.fieldTypeName==fieldType){
                    if(item.controlledUiFieldIds && !item.disableUiFieldIdsArr){
                        var part =item.controlledUiFieldIds.trim().split(/\s*;\s*/);
                        item.disableUiFieldIdsArr = [];
                        item.enabledUiFieldIdsArr = [];
                        for(var j=0; j<part.length; j++){
                            if(part[j].endsWith(":0")){
                                item.disableUiFieldIdsArr.push(part[j].substring(0, part[j].length-2));
                            }else if(part[j].endsWith(":1")){
                                item.enabledUiFieldIdsArr.push(part[j].substring(0, part[j].length-2));
                            }
                        }
                    }
                    return item;
                }
            }
        }

        return null;
    }


    openItemSelector(formTask: OnepageField) {
        formTask.templateFieldLocationOptions = this.templateFieldLocationOptions;
        
        this.taskConfigSelector.open(formTask, false, this.record.templateFileName, this.record.publishLanguage, this.getFileTypeOptionsForTemplate(), this.getDisabledUiFieldIds(formTask));
    }

    onTaskConfigSave(formTask: OnepageField) {
        console.debug('task config finished')
    }

    allowToDisplay(entityFieldId: string){
      
        if(this.onepageTemplateConfig && this.onepageTemplateConfig.onepageTemplateAdminFieldControls){
            for(var i=0; i<this.onepageTemplateConfig.onepageTemplateAdminFieldControls.length; i++){
                var dp = this.onepageTemplateConfig.onepageTemplateAdminFieldControls[i];
                if(dp.entityFieldId===entityFieldId){
                    return false;
                }
            }
        }
        return true;
    }

    isFieldNotCompleted(formTask: OnepageField): boolean{
        var fieldType = formTask.fieldType;
        if(fieldType){
            if(fieldType=='IMAGE'  || fieldType=='IMAGE_WITH_CUSTOMIZED_SIZE'  || fieldType=='IMAGE_IN_ROW1'  || fieldType=='IMAGE_IN_ROW2'){
                if(!formTask.imgFile){
                    formTask.isValid2Submit = false;
                    return true;
                }else{
                    formTask.isValid2Submit = true;
                }
            }
        }
        var rx = formTask.sequence && formTask.location && !fieldType;
        if(rx){
            formTask.isValid2Submit = false;
        }else{
            formTask.isValid2Submit = true;
        }
        return rx;
    }


    
    fileLoading: boolean = false;
    fileLoading4Icon: boolean = false;
      
    downloadFile(item, btnType) {
        // let item = this.imgFile;
        if(btnType=='ICON'){
            this.fileLoading4Icon = true;
        }else{
            this.fileLoading = true;
        }
        item._selected = true;
        this.binaryFileService.downloadFile(item.binaryFileId)
            .subscribe(blob => {

                FileSaver.saveAs(blob, item.fileName);
                if(btnType=='ICON'){
                    this.fileLoading4Icon = false;
                }else{
                    this.fileLoading = false;
                }
                item._selected = false;
            }, (error: ErrorResponse) => {
                if(btnType=='ICON'){
                    this.fileLoading4Icon = false;
                }else{
                    this.fileLoading = false;
                }
                item._selected = false;
                from(error.errors)
                    .pipe(
                        mergeMap(error => this.translate.get(error.errorCode)),
                        reduce((acc, value) => acc + value + '<br/>', '')
                    )
                    .subscribe(msg => {
                        this.translate.get(item.fileName)
                            .pipe(
                                switchMap(typeStr => this.translate.get('FAIL_TO_DOWNLOAD', { type: typeStr }))
                            )
                            .subscribe(title => {
                                toastr.options = {
                                    "closeButton": true,
                                    "positionClass": "toast-bottom-right",
                                    "timeOut": "0",
                                    "extendedTimeOut": "0"
                                }
                                toastr.error(msg, title);
                            });
                    });
            })
    }

    showDownloadButton(imgFileType) {
        
        if(imgFileType=='ICON'){
            if (!this.pageIconImage) {
                return false;
            }
            return this.pageIconImage.binaryFileId != null && !(this.pageIconImage._selected)
        }else{
            if (!this.imgFile) {
                return false;
            }
            return this.imgFile.binaryFileId != null && !(this.imgFile._selected)
        }
    }

    removeDocuments(imgFileType): void {
        if(imgFileType=='ICON'){
            if (!this.pageIconImage || this.pageIconImage.fileName == null) {
                return;
            }
            this.pageIconImage._selected = true;
            this.pageIconImage = null;
            this.documentFileSelect4Icon.nativeElement.value = '';
        }else{
            if (!this.imgFile || this.imgFile.fileName == null) {
                return;
            }
            this.imgFile._selected = true;
            this.imgFile = null;
            this.documentFileSelect.nativeElement.value = '';
        }
    }
    public onAttachmentUploadOutput(output: UploadOutput): void {
        if (output.file != null) {
            this.binaryFileApplication = null;
            if (this.imgFile == null) {
                this.imgFile = new BinaryFile();
            }
            this.binaryFileApplication = new ApplicationFile(output.file, null, MAX_DOCUMENT_FILE_SIZE);
            this.binaryFileApplication.readAsBase64((result) => {
                this.imgFile.content = result;
                this.imgFile.fileName = output.file.name;
                this.imgFile.fileSize = output.file.size;
                this.imgFile._fileName = output.file.name;
                this.imgFile._selected = true;
                this.documentFileSelect.nativeElement.value = '';
            })
        }
    }

    public onAttachmentUploadOutput4Icon(output: UploadOutput): void {
        if (output.file != null) {
            this.binaryFileApplication = null;
            if (this.pageIconImage == null) {
                this.pageIconImage = new BinaryFile();
            }
            this.binaryFileApplication = new ApplicationFile(output.file, null, MAX_DOCUMENT_FILE_SIZE);
            this.binaryFileApplication.readAsBase64((result) => {
                this.pageIconImage.content = result;
                this.pageIconImage.fileName = output.file.name;
                this.pageIconImage.fileSize = output.file.size;
                this.pageIconImage._fileName = output.file.name;
                this.pageIconImage._selected = true;
                this.documentFileSelect4Icon.nativeElement.value = '';
            })
        }
    }
}
